
import { requestUrl } from '../http/requestUrl'
export const getEnergyCount = {
    data() {
        return {

        };
    },
    computed: {},
    methods: {
        /**
         * 获取能量数量,未认证企业校验可用咨询次数
         * 所有问答都消耗一个能量(意图也消耗)
         * 内容生成或内容优化都消耗一个能量
        */
        async getEnergyCount(type, callback, failCallback) {
            let companyStatus = localStorage.getItem("companyStatus")
            let certifiedUserInfo = this.$store.getters["user/getCertifiedUserInfo"]
            if (companyStatus != "2") {
                let flag = false;
                if (type == 'send') {
                    flag = certifiedUserInfo.firstSend
                }
                if (type == 'create') {
                    flag = certifiedUserInfo.firstCreate
                }
                if (flag) {
                    let popupAiCreate = document.getElementsByClassName("popup-ai-create-content")
                    let mask = document.getElementsByClassName("mask-ckeditor")
                    let zIndex = 2555;
                    let markIndex = 2499
                    if (popupAiCreate && popupAiCreate[0]) {
                        zIndex = popupAiCreate[0].style.zIndex
                        popupAiCreate[0].style.zIndex = 0
                    }
                    if (mask && mask[0]) {
                        markIndex = mask[0].style.zIndex
                        mask[0].style.zIndex = 0
                    }
                    this.$confirm('当前操作将消耗一个能量，是否继续？', '提示', {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        type: 'warning'
                    }).then(() => {
                        if (popupAiCreate && popupAiCreate[0]) {
                            popupAiCreate[0].style.zIndex = zIndex
                        }
                        if (mask && mask[0]) {
                            mask[0].style.zIndex = markIndex
                        }
                        return this.updateCertifiedUserInfo(type, callback, failCallback)
                    }).catch(() => {
                        if (popupAiCreate && popupAiCreate[0]) {
                            popupAiCreate[0].style.zIndex = zIndex
                        }
                        if (mask && mask[0]) {
                            mask[0].style.zIndex = markIndex
                        }
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    })
                } else {
                    return this.updateCertifiedUserInfo(type, callback, failCallback)
                }
            } else {
                callback && callback()
            }
        },
        async updateCertifiedUserInfo(type, callback, failCallback) {
            let certifiedUserInfo = this.$store.getters["user/getCertifiedUserInfo"]
            await this.$http.get(`${requestUrl.certifiedUser.checkCertifiedUser}?userPhone=${certifiedUserInfo.userPhone}`).then(res => {
                if (res.data.code == '0' && res.data.data) {
                    if (res.data.data.canUseChatNum > 0) {
                        callback && callback()
                        certifiedUserInfo.canUseChatNum = res.data.data.canUseChatNum - 1
                        if (type == 'send') {
                            certifiedUserInfo.firstSend = false
                        } else {
                            certifiedUserInfo.firstCreate = false
                        }
                        this.$http.post(requestUrl.certifiedUser.update, certifiedUserInfo).then((res) => {
                            if (res.data.code == 0) {
                                this.$store.dispatch("user/UPDATE_CERTIFIED_USER_INFO", res.data.data)
                            }
                        })
                    } else {
                        this.$message({
                            showClose: true,
                            message: '您剩余的能量不足，如需继续使用请联系：13911657650　　',
                            duration: 0,
                            type: 'warning'
                        });
                        failCallback && failCallback()
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: '您剩余的能量不足，如需继续使用请联系：13911657650　　',
                        duration: 0,
                        type: 'warning'
                    });
                    failCallback && failCallback()
                }
            })
        }
    }
}